module.exports = __webpack_public_path__ + "img/leiterinnen_karolis-wuest.b244fede.png";